import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Header.css';

function Header({ activeMenu, onMenuClick }) {
  const [localeOpen, setLocaleOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleHomeClick = (e) => {
    e.preventDefault();
    onMenuClick('home');
    navigate('/dashboard/KR');
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/auth/realms/seller/protocol/openid-connect/auth');
  };

  return (
    <div className="rs-header-wrapper">
      <div id="rsGnb64f41e20" className="rs-gnb">
        <a id="rsLogo64f41e20" className="rs-logo" href="/dashboard/KR" onClick={(e) => { e.preventDefault(); navigate('/dashboard/KR'); }}>
          <img src="//img1a.coupangcdn.com/image/coupang/retail/common/logo/supplier-hub-logo.svg" alt="Coupang Supplier Hub" />
        </a>
        
        <ul id="rsNav64f41e20" className="rs-nav rs-nav--on">
          <li><a href="/dashboard/KR" onClick={handleHomeClick} className={activeMenu === 'home' ? 'rs--on' : ''}>홈</a></li>
          <li className={activeMenu === 'products' ? 'rs-nav-open' : ''}>
            <a href="/products" role="button" onClick={(e) => { e.preventDefault(); onMenuClick('products'); }} className={activeMenu === 'products' ? 'rs--on' : ''}>
              상품<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li className={activeMenu === 'logistics' ? 'rs-nav-open' : ''}>
            <a href="/logistics" role="button" onClick={(e) => { e.preventDefault(); onMenuClick('logistics'); }} className={activeMenu === 'logistics' ? 'rs--on' : ''}>
              물류<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li className={activeMenu === 'settlement' ? 'rs-nav-open' : ''}>
            <a href="/settlement" role="button" onClick={(e) => { e.preventDefault(); onMenuClick('settlement'); }} className={activeMenu === 'settlement' ? 'rs--on' : ''}>
              정산<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li className={activeMenu === 'analytics' ? 'rs-nav-open' : ''}>
            <a href="/rpd/web-v2" role="button" onClick={(e) => { e.preventDefault(); onMenuClick('analytics'); }} className={activeMenu === 'analytics' ? 'rs--on' : ''}>
              애널리틱스<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li><a href="/retail/store/guide" onClick={(e) => { e.preventDefault(); onMenuClick('myshop'); }}>마이샵</a></li>
          <li><a href="/marketing/ads-center/home" onClick={(e) => { e.preventDefault(); onMenuClick('ads'); }}>광고 관리</a></li>
          <li className={activeMenu === 'live' ? 'rs-nav-open' : ''}>
            <a href="" role="button" onClick={(e) => { e.preventDefault(); onMenuClick('live'); }}>
              라이브 &amp; 숏츠<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li className={activeMenu === 'promotion' ? 'rs-nav-open' : ''}>
            <a href="/promotion" role="button" className="rs-new" onClick={(e) => { e.preventDefault(); onMenuClick('promotion'); }}>
              프로모션<i className="rs-icon rs-icon__caret--down"></i>
            </a>
          </li>
          <li><a href="/vine/web/" onClick={(e) => { e.preventDefault(); onMenuClick('vine'); }}>쿠팡체험단</a></li>
          <li><a href="/contract/list" onClick={(e) => { e.preventDefault(); onMenuClick('contract'); }}>계약</a></li>
        </ul>
        
        <div id="rsMisc64f41e20" className="rs-misc">
          <a className="rs-sl rs-btn rs-sl--on" href="/supplier/qna/ko/requests/new" target="_blank" rel="noreferrer noopener">온라인 문의</a>
          <a className="rs-sl rs-btn rs-sl--on" href="/supplier/qna/ko/requests" target="_blank" rel="noreferrer noopener">나의 문의내역</a>
          <a className="rs-sl rs-btn rs-sl--on" href="/help" rel="noreferrer noopener">도움말</a>
        </div>
        
        <div id="rsAccount64f41e20" className={`rs-account rs-account--on ${accountOpen ? 'rs-account--open' : ''}`}>
          <button className="rs-btn" type="button" onClick={() => setAccountOpen(!accountOpen)}>
            <span>{user?.brandName || '라이크존'}</span>
            <i className="rs-icon rs-icon__caret--down"></i>
          </button>
          <ul className="">
            <li><a>Company Code: <span className="rs-account__menu--primary">{
              user?.username === 'likezone' ? 'A00968391' :
              user?.username === 'traderb' ? 'A01361508' :
              user?.username === 'betweeninc' ? 'A01275313' :
              'A00886069'
            }</span></a></li>
            <li className="rs-dropdown-divider"></li>
            <li><a href="/settings">내 계정</a></li>
            <li><a href="/sub-account/view">Child Account</a></li>
            <li className="rs-dropdown-divider"></li>
            <li><a href="#" onClick={handleLogout}>로그아웃</a></li>
          </ul>
        </div>
        
        <div id="rsLocale64f41e20" className={`rs-locale ${localeOpen ? 'rs-locale--open' : ''}`}>
          <button className="rs-btn" type="button" onClick={() => setLocaleOpen(!localeOpen)}>
            <i className="rs-icon rs-icon__globe"></i>
            <span>한국어</span>
            <i className="rs-icon rs-icon__caret--down"></i>
          </button>
          <ul>
            <li><button role="button" type="button" lang="ko">한국어</button></li>
            <li><button role="button" type="button" lang="en">English</button></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Header;
